/** Values of retained metadata offered for choosing (ANN-19, ANON-06); the engine knows the full DICOM lists. */

/** Body parts of pediatric fracture reading. */
export const BODY_PARTS = [
  'HAND',
  'FINGER',
  'THUMB',
  'WRIST',
  'FOREARM',
  'ELBOW',
  'UPPERARM',
  'HUMERUS',
  'SHOULDER',
  'CLAVICLE',
  'HIP',
  'FEMUR',
  'KNEE',
  'LOWERLEG',
  'ANKLE',
  'FOOT',
  'TOE',
  'SKULL',
  'CHEST',
]
export const VIEWS = ['AP', 'PA', 'LAT', 'LL', 'RL', 'OBL', 'LLO', 'RLO', 'FRONTAL']
export const SIDES = ['L', 'R', 'B', 'U'] as const
export const SEXES = ['F', 'M', 'O'] as const
